import { Theme, css } from "@mui/material";

export const sharedStyles = {
  firstLevelNodeText: (theme: Theme) =>
    css({
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
    }),
  listItemHeading: (theme: Theme) =>
    css({
      ".MuiTypography-root": {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
      },
    }),
  sectionNodeLabelContainer: css({
    backgroundColor: "#1919190A",
  }),
  headerContainer: css({
    height: 48,
    padding: "8px 16px",
    backgroundColor: "#1919190A",
    display: "flex",
    alignItems: "center",
  }),
  headerDivider: css({
    marginBottom: 8,
  }),
  headerText: (theme: Theme) =>
    css({
      margin: 0,
      color: theme.palette.common.black,
      fontSize: theme.typography.pxToRem(12),
      textTransform: "uppercase",
      fontWeight: theme.typography.fontWeightRegular,
      letterSpacing: "0.06em",
      position: "relative",
    }),
};
